var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.25,
    stroke: "#555555",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8148 17.5611C12.8148 18.0336 12.45 18.4166 12.0001 18.4166C11.5501 18.4166 11.1853 18.0336 11.1853 17.5611C11.1853 17.0886 11.5501 16.7056 12.0001 16.7056C12.45 16.7056 12.8148 17.0886 12.8148 17.5611Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.29 12.9773C13.0016 13.1167 12.8149 13.4222 12.8149 13.7551V14.1392C12.8149 14.6114 12.4507 14.9947 12.0002 14.9947C11.5496 14.9947 11.1854 14.6114 11.1854 14.1392V13.7551C11.1854 12.7565 11.7443 11.8412 12.6072 11.4228C13.4375 11.0216 14.0371 9.95628 14.0371 9.43352C14.0371 8.25467 13.1238 7.29467 12.0002 7.29467C10.8766 7.29467 9.96318 8.25467 9.96318 9.43352C9.96318 9.90584 9.59884 10.2892 9.14826 10.2892C8.69769 10.2892 8.3335 9.90584 8.3335 9.43352C8.3335 7.31096 9.97854 5.5835 12.0002 5.5835C14.0218 5.5835 15.6668 7.31096 15.6668 9.43352C15.6668 10.5895 14.7118 12.2886 13.29 12.9773Z",
    fill: "#555555"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.d9db8208b7cfbe2a6ed171d846d7c359.svg";